import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { customerService } from "../../services/CustomerService";

export default function ProductReturnListPage() {
  const [returns, setReturns] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchReturns = async () => {
    try {
      setLoading(true);
      const res = await customerService.listReturns();
      setReturns(res.data || []);
    } catch (err) {
      console.error("İadeler getirilirken hata:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReturns();
  }, []);

  const dateBodyTemplate = (rowData) => {
    return new Date(rowData.returnDate).toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const amountBodyTemplate = (rowData) => {
    return (
      <span className="font-bold text-slate-900">
        ₺{rowData.totalAmount.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}
      </span>
    );
  };

  return (
    <div className="animate-fade-in">
      <div className="bg-white shadow-xl border border-slate-200 rounded-3xl overflow-hidden mb-6">
        <div className="px-8 py-6 bg-slate-50/50 border-b !bg-slate-300 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-2xl !bg-orange-500 flex items-center justify-center shadow-lg shadow-orange-200">
              <i className="pi pi-refresh text-white text-xl"></i>
            </div>
            <div>
              <h1 className="text-2xl font-black text-slate-900 m-0">İade Listesi</h1>
              <p className="text-xs font-bold italic">Tüm ürün iade işlemlerini buradan takip edebilirsiniz.</p>
            </div>
          </div>
          <Tag value={`${returns.length} İŞLEM`} className="bg-slate-900 text-xs font-black px-3 py-1.5" />
        </div>

        <div className="p-0">
          <DataTable
            value={returns}
            loading={loading}
            rows={20}
            paginator
            responsiveLayout="scroll"
            emptyMessage="Henüz iade işlemi bulunmuyor."
            className="p-datatable-lg"
            rowClassName={() => 'hover:bg-slate-50/50 transition-colors'}
          >
            <Column field="returnDate" header="TARİH" body={dateBodyTemplate} sortable className="text-slate-600 font-bold" />
            <Column field="customerName" header="MÜŞTERİ" sortable className="text-slate-900 font-black" />
            <Column field="productName" header="ÜRÜN" sortable className="text-blue-600 font-bold" />
            <Column field="quantity" header="ADET" sortable body={(rowData) => <Tag value={rowData.quantity} className="bg-slate-100 text-slate-700 border border-slate-200 font-black" />} />
            <Column field="unitPrice" header="BİRİM FİYAT" body={(rowData) => `₺${rowData.unitPrice.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}`} />
            <Column field="totalAmount" header="TOPLAM TUTAR" body={amountBodyTemplate} sortable />
            <Column field="description" header="AÇIKLAMA" className="text-slate-500 text-sm" />
          </DataTable>
        </div>
      </div>
    </div>
  );
}
